<ng-container *ngIf="totalPages > 1">
  <div data-test="MoB6FcWv" class="pagination" [hidden]="totalPages === 1">
    <div data-test="MCL5jozp" [hidden]="currentPage === 1" class="pagination__button">
      <button
        data-test="v65VNMSx"
        (click)="prevPage()"
        class="button button_secondary button_square button_square-sm"
      >
        <i data-test="SimD542_" class="material-icons md-12">keyboard_arrow_left</i>
      </button>
    </div>
    <ng-container *ngIf="totalPages <= 10">
      <div
        data-test="At-NgtlR"
        class="pagination__item"
        (click)="handleClick(page.number)"
        [class.active]="page.number === currentPage"
        *ngFor="let page of pages"
      >
        {{ page.number }}
      </div>
    </ng-container>
    <ng-container *ngIf="totalPages > 10">
      <ng-container *ngIf="currentPage < 6">
        <div
          data-test="arsMoSTY"
          class="pagination__item"
          (click)="handleClick(page.number)"
          [class.active]="page.number === currentPage"
          *ngFor="let page of pages.slice(0, 6)"
        >
          {{ page.number }}
        </div>
      </ng-container>
      <ng-container *ngIf="currentPage > 5">
        <div
          data-test="C-K9XdLa"
          class="pagination__item"
          (click)="handleClick(page.number)"
          [class.active]="page.number === currentPage"
          *ngFor="let page of pages.slice(0, 2)"
        >
          {{ page.number }}
        </div>
        ...
        <div
          data-test="p42Qw0Il"
          class="pagination__item"
          (click)="handleClick(page.number)"
          [class.active]="page.number === currentPage"
          *ngFor="
            let page of pages.slice(
              currentPage - 3,
              currentPage < pages.length - 3 ? currentPage + 2 : pages.length
            )
          "
        >
          {{ page.number }}
        </div>
      </ng-container>
      <ng-container *ngIf="pages.length > 7 && currentPage < pages.length - 3">
        <ng-container *ngIf="currentPage + 2 < pages.length - 2">...</ng-container>
        <div
          data-test="WSuX2CEY"
          class="pagination__item"
          (click)="handleClick(page.number)"
          [class.active]="page.number === currentPage"
          *ngFor="let page of pages.slice(pages.length - 2, pages.length)"
        >
          {{ page.number }}
        </div>
      </ng-container>
    </ng-container>
    <div
      data-test="y8tHc8a3"
      [hidden]="currentPage === totalPages"
      class="pagination__button"
    >
      <button
        data-test="kaP7a2sk"
        (click)="nextPage()"
        class="button button_secondary button_square button_square-sm"
      >
        <i data-test="bg8h09gY" class="material-icons md-12">keyboard_arrow_right</i>
      </button>
    </div>
  </div>
</ng-container>
